export const ToppersList = [
    {
        id:1,
        standard:"XII STANDARD (12th)",
        image:"/images/Students/Toppers/12Toppers.webp"
    },
    {
        id:2,
        standard:"XI STANDARD (11th)",
        image:"/images/Students/Toppers/11Toppers.webp"
    },
    {
        id:3,
        standard:"X STANDARD (10th)",
        image:"/images/Students/Toppers/10Toppers.webp"
    }
];